import axios from "axios";

// ✅ Sirf .env se URL lega
const API_BASE_URL = process.env.REACT_APP_API_URL?.replace(/\/$/, ''); // Remove trailing slash if present

// ✅ Image URL bhi same domain se lega
const BASE_IMG = API_BASE_URL?.replace('/api', '');

/* ================= IMAGE HELPER ================= */
const getImageUrl = (img, type = "test") => {
  if (!img) return null;

  if (img.startsWith("http")) return img;

  const clean = img.trim().replace(/\s/g, "%20");

  return type === "lab"
    ? `${BASE_IMG}/LabImage/${clean}`
    : `${BASE_IMG}/TestMasterImage/${clean}`;
};

/* ================= FETCH LAB ================= */
export const fetchLabDetails = async (labId) => {
  try {
    const res = await axios.get(`${API_BASE_URL}/Lab?id=${labId}`);
    const data = res.data;

    const lab = Array.isArray(data)
      ? data.find((l) => Number(l.id) === Number(labId))
      : data;

    if (!lab) return null;

    return {
      ...lab,
      image: getImageUrl(
        lab.lab_image || lab.image || lab.labImage,
        "lab"
      ),
    };
  } catch (err) {
    console.error("❌ LAB API ERROR:", err);
    return null;
  }
};

/* ================= FETCH TESTS ================= */
export const fetchLabTests = async ({
  labId,
  pageNumber = 1,
  pageSize = 2000,
  search = "",
  symptomId = 0,
}) => {
  try {
    const payload = {
      name: search || "",
      labId: Number(labId),
      symptomId: Number(symptomId),
      pageNumber,
      pageSize,
    };

    console.log("📤 TEST API PAYLOAD:", payload);

    const res = await axios.post(`${API_BASE_URL}/Lab/TestSearch`, payload);

    console.log("📥 TEST API RESPONSE:", res.data);

    const list = res.data?.data || [];

    return list.map((t) => {
      let img = t.testImage || t.TestImage;

      if (!img && t?.lab?.lab_image) {
        img = getImageUrl(t.lab.lab_image, "lab");
      }

      if (img && !img.startsWith("http")) {
        img = getImageUrl(img, "test");
      }

      return {
        ...t,
        testImage: img || "https://placehold.co/60x60?text=Test",
      };
    });

  } catch (err) {
    console.error("❌ TEST API ERROR:", err?.response || err);
    return [];
  }
};

/* ================= FETCH PACKAGES ================= */
export const fetchPackages = async (labId) => {
  try {
    const res = await axios.get(`${API_BASE_URL}/Package?id=${labId}`);
    return Array.isArray(res.data) ? res.data : res.data?.data || [];
  } catch (err) {
    console.error("❌ PACKAGE API ERROR:", err);
    return [];
  }
};

/* ================= FETCH LAB DISTANCE ================= */
export const fetchLabDistance = async ({ labId, userLat, userLng }) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/Lab/GetLabDistance?labId=${labId}&lat=${userLat}&lng=${userLng}`
    );
    
    console.log("📏 Distance API Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ Distance API Error:", error?.response || error);
    return null;
  }
};